// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/Constellation.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Header {
    background-image: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    padding: 5rem 0;
    color: white;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  
  .hero-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 10rem);
    text-align: center;
    font-family: 'Montserrat', sans-serif;
  }
  
  .hero-title {
    margin-top: 0;
    margin-bottom: 2rem;
    font-size: 6rem;
    font-weight: 800;
    line-height: 1.2;
    color: #f9f7f7;
  }
  
  .hero-subtitle {
    font-size: 2.5rem;
    font-weight: 500;
    color: #87868b;
    margin-bottom: 2rem;
  }
  
  .hero-description {
    font-size: 1.25rem;
    line-height: 1.5;
    margin-bottom: 2rem;
    color: rgb(242, 241, 239);
  }
  
  .btn {
    display: inline-block;
    padding: 2rem 2.5rem 2 2;
    border-radius: 2rem;
    font-size: 1.25rem;
    font-weight: 500;
    text-align: center;
    text-decoration: none;
    transition: background-color 0.3s ease-in-out;
    display: inline-block;

  }
  
  .btn:hover {
    background-color: #f4f4f4;
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1 rem;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/css/Header.css"],"names":[],"mappings":"AAAA;IACI,4GAAoG;IACpG,sBAAsB;IACtB,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,2DAA2D;EAC7D;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,6CAA6C;IAC7C,qBAAqB;;EAEvB;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB","sourcesContent":["#Header {\n    background-image: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(\"../img/Constellation.jpg\");\n    background-size: cover;\n    background-position: center;\n    padding: 5rem 0;\n    color: white;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  }\n  \n  .hero-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: calc(100vh - 10rem);\n    text-align: center;\n    font-family: 'Montserrat', sans-serif;\n  }\n  \n  .hero-title {\n    margin-top: 0;\n    margin-bottom: 2rem;\n    font-size: 6rem;\n    font-weight: 800;\n    line-height: 1.2;\n    color: #f9f7f7;\n  }\n  \n  .hero-subtitle {\n    font-size: 2.5rem;\n    font-weight: 500;\n    color: #87868b;\n    margin-bottom: 2rem;\n  }\n  \n  .hero-description {\n    font-size: 1.25rem;\n    line-height: 1.5;\n    margin-bottom: 2rem;\n    color: rgb(242, 241, 239);\n  }\n  \n  .btn {\n    display: inline-block;\n    padding: 2rem 2.5rem 2 2;\n    border-radius: 2rem;\n    font-size: 1.25rem;\n    font-weight: 500;\n    text-align: center;\n    text-decoration: none;\n    transition: background-color 0.3s ease-in-out;\n    display: inline-block;\n\n  }\n  \n  .btn:hover {\n    background-color: #f4f4f4;\n  }\n  .btn-group {\n    display: flex;\n    justify-content: space-between;\n    padding: 1rem 1 rem;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
